import {Component, Input} from '@angular/core';
import {Biowetter, BiowetterVorhersage} from '../../../../../../../model/vorhersagen/biowetter';

@Component({
  selector: 'app-biowetter-zone',
  templateUrl: './biowetter-zone.component.html',
  styleUrls: ['./biowetter-zone.component.css']
})
export class BiowetterZoneComponent {

  private readonly NO_SELECTION = -1;

  @Input()
  biowetter: Biowetter;
  selectedIndex = this.NO_SELECTION;

  updateSelectedVorhersage(selectedIndex: number): void {
    this.selectedIndex = this.selectedIndex === selectedIndex ? this.NO_SELECTION : selectedIndex;
  }

  hasVorhersageSelected(): boolean {
    return this.selectedIndex !== -1;
  }

  getSelectedVorhersage(): BiowetterVorhersage {
    return this.biowetter.vorhersagen[this.selectedIndex];
  }

}
